import React from 'react';
import { cn } from '../lib/utils';
import { TableCell, TableRow } from './Table';

export function Skeleton({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
    return (
        <div
            className={cn('animate-pulse rounded-md bg-zinc-950/10 dark:bg-white/10', className)}
            {...props}
        />
    );
}

export function TableSkeletonRows({ rows = 3, columns }: { rows?: number; columns: number }) {
    return (
        <>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <TableCell key={colIndex}>
                            <Skeleton className="h-4 w-full max-w-32" />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
}

export function ChartSkeleton({ className }: { className?: string }) {
    return <Skeleton className={cn('h-full w-full', className)} />;
}
